import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const createNotes = (object_id, object_name, notes_text, user_id) => {
    return axios.post(API + "helper/note-add/", {
        object_id,
        object_name,
        notes_text,
        user_id,
    }, { headers: authHeader(), });
}

const deleteNotes = (id) => {
    return axios.delete(API + `helper/note-delete/${id}`, { headers: authHeader() });
}

const editNotes = (id, object_id, object_name, notes_text) => {
    return axios.put(API + `helper/note-update/${id}`, {
        object_id,
        object_name,
        notes_text,
    }, { headers: authHeader() });

}

const GetNotesService = {
    createNotes,
    deleteNotes,
    editNotes
};
export default GetNotesService;